export default {
  /**
   * @method 设置Token
   */
  setToken({
    commit
  }, token) {
    return new Promise((resolve) => {
      commit('SET_DOCTOR_TOKEN', token);
      resolve();
    });
  },
  /**
   * @method 专家退出登录
   * @param commit
   */
  Logout({
    commit
  }) {
    return new Promise((resolve) => {
      commit('CLEAR_CLINIC_TOKEN');
      resolve();
    });
  },
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js